import { Products } from "src/types/ClientDetails";

const LOCATION = {
  IN_PROGRESS: "InProgress",
  REVIEW: "Review",
  BASE: "Base",
  CUSTOM: "Custom",
};

const TOAST_MESSAGE = {
  FAILED_TO_CONNECT: "Failed to Connect",
  INTERNAL_SERVER_ERROR: "Internal Server Error",
};

const PRODUCTSLIST: Products[] = [
  {
    productId: 1,
    productName: "MAO",
  },
  {
    productId: 2,
    productName: "MAWM",
  },
];

export { LOCATION, PRODUCTSLIST, TOAST_MESSAGE };
